import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateAdminStudioBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const createAdminStudio = createAsyncThunk<string, CreateAdminStudioBody, { extra: Partial<Dependencies> }>(
  "admin/studio/create",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.createStudio(body);
  },
);

export const resetCreateAdminStudio = createAction("admin/studio/resetCreate");
